export const shopConstants = {

    IS_SHOP_PUBLIC_REQUEST: "IS_SHOP_PUBLIC_REQUEST",
    IS_SHOP_PUBLIC_SUCCESS: "IS_SHOP_PUBLIC_SUCCESS",
    IS_SHOP_PUBLIC_ERROR: "IS_SHOP_PUBLIC_ERROR",

    GET_PUBLIC_SHOP_REQUEST: "GET_PUBLIC_SHOP_REQUEST",
    GET_PUBLIC_SHOP_SUCCESS: "GET_PUBLIC_SHOP_SUCCESS",
    GET_PUBLIC_SHOP_ERROR: "GET_PUBLIC_SHOP_ERROR",

    GET_PUBLIC_SHOP_CONFIG_REQUEST: "GET_PUBLIC_SHOP_CONFIG_REQUEST",
    GET_PUBLIC_SHOP_CONFIG_SUCCESS: "GET_PUBLIC_SHOP_CONFIG_SUCCESS",
    GET_PUBLIC_SHOP_CONFIG_ERROR: "GET_PUBLIC_SHOP_CONFIG_ERROR",

}